import {usePage} from "@inertiajs/react";
import {toast} from "@/hooks/use-toast.ts";
import {useEffect} from "react";
import {Flash} from "../../types/types.ts";

export interface PagePropsWithFlash {
    flash: Flash
}

const FlashMessages = () => {
    const pageProps = usePage().props as unknown as PagePropsWithFlash;
    const flash = pageProps.flash || {};
    useEffect(() => {
        // Check for flash messages and show them as toasts
        if (flash.notice) {
            toast({
                title: "Success",
                description: flash.notice,
                variant: "default",
            })
        }

        if (flash.error) {
            toast({
                title: "Error",
                description: flash.error,
                variant: "destructive",
            })
        }
    }, [flash])

    return null // This component doesn't render anything, just handles the side effect
}

export default FlashMessages